import React, { Fragment } from 'react';
import skyport1 from '../../../../../images/skyport1.jpg';
import skyport8 from '../../../../../images/skyport8.jpg';
import skyport9 from '../../../../../images/skyport9.jpg';

const SkyportWalking = () => (
  <Fragment>
    <div>
      <img
        className="faq-image-compress"
        src={skyport1}
        alt="Parking Lot"
      />
      <p>Enter the parking lot through the main entrance</p>
    </div>
    <div>
      <img
        className="faq-image-compress"
        src={skyport8}
        alt="Parking Lot"
      />
      <p>Enter the booth and take the elevator to the 3rd floor</p>
    </div>

    <div>
      <img
        className="faq-image-compress"
        src={skyport9}
        alt="Parking Lot"
      />
      <p>
        Exit the elevator and you will see all Autzu cars are parked on the
        3rd floor.
      </p>
    </div>
  </Fragment>
);

export default SkyportWalking;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingLotData/Skyport/SkyportWalking.js